import { LineChart, Line, ResponsiveContainer } from 'recharts'
import { formatCurrency, formatPercentage, getPriceChangeColor, getPriceChangeBg } from '../utils/formatters'

const MarketCard = ({ market }) => {
  const { symbol, name, price, change24h, volume, sparklineData } = market

  // Transform sparkline data for Recharts
  const chartData = sparklineData.map((value, index) => ({
    index,
    price: value
  }))

  const isPositive = change24h > 0

  return (
    <div className="card group cursor-pointer hover:border-white/20">
      <div className="flex justify-between items-start mb-4">
        <div>
          <h3 className="text-lg font-bold text-white group-hover:text-gray-200 transition-colors">
            {symbol}
          </h3>
          <p className="text-sm text-gray-500">{name}</p>
        </div>
        <div className={`px-3 py-1 rounded-full text-sm font-medium ${getPriceChangeBg(change24h)}`}>
          <span className={getPriceChangeColor(change24h)}>
            {formatPercentage(change24h)}
          </span>
        </div>
      </div>

      <div className="mb-4">
        <div className="text-2xl font-bold text-white mb-1">
          {formatCurrency(price)}
        </div>
        <div className="text-sm text-gray-500">
          Vol: {volume}
        </div>
      </div>

      {/* Sparkline */}
      <div className="h-16 -mx-2">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <Line
              type="monotone"
              dataKey="price"
              stroke={isPositive ? '#00C2A8' : '#E63946'}
              strokeWidth={2}
              dot={false}
              animationDuration={300}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Hover Effect Indicator */}
      <div className="mt-4 pt-4 border-t border-charcoal-800 opacity-0 group-hover:opacity-100 transition-opacity">
        <button className="text-sm text-white font-medium flex items-center">
          View Details
          <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default MarketCard
